import React, { useEffect, useState } from "react";
import Header from "./Header";
import Footer from "./Footer";
import topback from "../images/beetitle.png";

function Ssr() {
  const Urlmain = "https://gcbeetan.co.in/admin/uploads/";
  const [data, setData] = useState([]);
  const [open2023, setOpen2023] = useState(false);
  const [open2024, setOpen2024] = useState(false);

  useEffect(() => {
    fetch("https://gcbeetan.co.in/admin/api/api.php/notifications/sar")
      .then((res) => res.json())
      .then((res) => setData(res))
      .catch((err) => console.error(err));
  }, []);

  // Filter 2023 items
  const sar2023 = data.filter(
    (item) =>
      item.title && item.title.toLowerCase().includes("2023")
  );
  const sar2024 = data.filter(
    (item) =>
      item.title && item.title.toLowerCase().includes("2024")
  );

  return (
    <>
      <Header />

      <section
        className="content-section title-top"
        style={{ backgroundImage: `url(${topback})` }}
      >
        <div className="pattern-overlay">
          <div className="container">
            <h2>SAR</h2>
          </div>
        </div>
      </section>

      <section className="container mt-5 mb-5">

        {/* 📁 Folder */}
        <div className="sar-folder">
          <h3
            className="folder-heading clickable"
            onClick={() => setOpen2023(!open2023)}
          >
            {open2023 ? "📂" : "📁"} SAR 2023-24
          </h3>

          {open2023 && (
            <ul className="folder-list">
              {sar2023.map((item, index) => (
                <li key={index}>
                  ▢{" "}
                  <a
                    href={Urlmain + item.myfile}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {item.title}
                  </a>
                </li>
              ))}
            </ul>
          )}
        </div>
         <div className="sar-folder">
          <h3
            className="folder-heading clickable"
            onClick={() => setOpen2024(!open2024)}
          >
            {open2024 ? "📂" : "📁"} SAR 2024-25
          </h3>

          {open2024 && (
            <ul className="folder-list">
              {sar2024.map((item, index) => (
                <li key={index}>
                  ▢{" "}
                  <a
                    href={Urlmain + item.myfile}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {item.title}
                  </a>
                </li>
              ))}
            </ul>
          )}
        </div>

      </section>

      <Footer />
    </>
  );
}

export default Ssr;
